import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class DataViewerFeatureService {
    private _router = inject(Router);

    goToFeature() {
        this._router.navigate(['/', 'data-viewer']);
    }
}
